<template>
	<div class="security">
		<div :class="[{ level_on: securityLevel >= 1 }, 'level_1', 'box']">
			<p class="mb_10">자산 선택</p>
			<select class="contact_type mb_10" v-model="typeSeq">
				<option>비트코인</option>
				<option>비트코인</option>
				<option>비트코인</option>
			</select>
			<div>
				<p class="mb_10">자산 주소</p>
				<input
					class="mb_10"
					type="text"
					:placeholder="$t('merchant.address.text3')"
					:value="selectedAccountInfo?.address"
				/>
				<button class="button_bg_red mb_20" @click="sendVerificationCode">
					등록하기
				</button>
			</div>
			<!-- <div class="security_email d_flex">
				<span
					class="circle"
					:class="{
						circle_on: securityLevel >= 1,
						circle_url: securityLevel < 1,
					}"
				></span>

				<div class="icon"></div>
				<p class="text_g">{{ $t('merchant.security.level1') }}</p>
				<h4 class="mb_15">{{ $t('merchant.security.email') }}</h4>
				<div class="display_status uncompleted" v-if="securityLevel === 0">
					{{ $t('merchant.security.authStatus.no') }}
				</div>
				<div class="display_status completed" v-if="securityLevel >= 1">
					{{ $t('merchant.security.authStatus.ok') }}
				</div>
			</div>
			<div class="level_2 box" :class="{ level_on: securityLevel >= 2 }">
				<span
					class="circle"
					:class="{
						circle_on: securityLevel >= 2,
						circle_url: securityLevel < 2,
					}"
				></span>
				<div class="icon"></div>
				<p class="text_b">{{ $t('merchant.security.level2') }}</p>
				<h4 class="mb_15">{{ $t('merchant.security.kyc') }}</h4>
				<div class="display_status uncompleted" v-if="securityLevel < 2">
					{{ $t('merchant.security.authStatus.no') }}
				</div>
				<div class="display_status completed" v-if="securityLevel >= 2">
					{{ $t('merchant.security.authStatus.ok') }}
				</div>
			</div>
			<div class="level_3 box" :class="{ level_on: securityLevel >= 3 }">
				<span
					class="circle"
					:class="{
						circle_on: securityLevel >= 3,
						circle_url: securityLevel < 3,
					}"
				></span>
				<div class="icon"></div>
				<p class="text_p">{{ $t('merchant.security.level3') }}</p>
				<h4 class="mb_15">{{ $t('merchant.security.otp') }}</h4>
				<div class="display_status uncompleted" v-if="securityLevel < 3">
					{{ $t('merchant.security.authStatus.no') }}
				</div>
				<div class="display_status completed" v-if="securityLevel >= 3">
					{{ $t('merchant.security.authStatus.ok') }}
				</div>
			</div> -->
			<!--			<div class="level_4 box" :class="{ level_on: securityLevel >= 4 }">-->
			<!--				<span-->
			<!--					class="circle"-->
			<!--					:class="{-->
			<!--						circle_on: securityLevel >= 4,-->
			<!--						circle_url: securityLevel < 4,-->
			<!--					}"-->
			<!--				></span>-->
			<!--				<div class="icon"></div>-->
			<!--				<p class="text_o">{{ $t('merchant.security.level4') }}</p>-->
			<!--				<h4 class="mb_15">{{ $t('merchant.security.address') }}</h4>-->
			<!--				<div class="display_status uncompleted" v-if="securityLevel < 4">-->
			<!--					{{ $t('merchant.security.authStatus.no') }}-->
			<!--				</div>-->
			<!--				<div class="display_status completed" v-if="securityLevel >= 4">-->
			<!--					{{ $t('merchant.security.authStatus.ok') }}-->
			<!--				</div>-->
			<!--			</div>-->
		</div>

		<!-- <div class="limit gray_back">
			<p class="mb_20">{{ $t('merchant.security.title3') }}</p>
			<ul>
				<li>- {{ $t('merchant.security.text1') }}</li>
				<li>- {{ $t('merchant.security.text2') }}</li>
				<li>- {{ $t('merchant.security.text3') }}</li>
				<li>- {{ $t('merchant.security.text4') }}</li>
			</ul>
		</div> -->
	</div>
</template>

<script>
export default {
	name: 'Security',
	data() {
		return {
			showTab: null,
			securityLevel: 0,
		};
	},
};
</script>
